import { hideLoading } from "components/Loading";
import { showLoading } from "components/Loading";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Button, FormGroup, Input, Modal, ModalBody, Table } from "reactstrap";
import contratoService from "services/ContratoService";
import { TipoContratoEnum } from "services/ContratoService";
import ordemServicoService, { StatusOrdemServicoEnum } from "services/OrdemServicoService";
import { erroInesperado } from "services/Utils";
import { onlyNumbers } from "services/Utils";
import { extrairItensArvore, formatNumber } from "services/Utils";

const MODO = {
  SELECAO_ITEM: 1,
  COMPLETAR: 2
}

export default function ModalIncluir({ config, onClosed, idContrato, itensAtuais, onChange }) {
  const [data, setData] = useState({
    modo: MODO.SELECAO_ITEM,
    quantidade: config?.tipoContrato == TipoContratoEnum.SEMAFORICO ? 1 : 0,
    justificativa: ''
  })
  const [itensContrato, setItensContrato] = useState()

  const justificativaObrigatoria = useMemo(() => {
    return config?.os?.idStatus != StatusOrdemServicoEnum.PENDENTE
  }, [config])

  const justificativaValida = useMemo(() => {
    if (!justificativaObrigatoria) return true
    return !!data.justificativa?.trim()
  }, [data.justificativa, justificativaObrigatoria])

  useEffect(() => {
    setData({
      modo: MODO.SELECAO_ITEM,
      quantidade: config?.tipoContrato == TipoContratoEnum.SEMAFORICO ? 1 : 0,
      justificativa: ''
    })
  }, [config])

  useEffect(() => {
    contratoService.getItems(idContrato).then(res => {
      if (res.success) {
        setItensContrato(extrairItensArvore({ filhos: res.data }))
      }
    })
  }, [idContrato])

  const itensFiltrados = useMemo(() => {
    if (!itensContrato || !itensAtuais)
      return []

    return itensContrato
      .filter(ic => !itensAtuais.some(ia => ia.id == ic.id))
      .filter(ic => {
        if (!data.termo) return true
        if ((ic.codigo || '').indexOf(data.termo) != -1) return true
        if ((ic.descricao || '').toLowerCase().indexOf(data.termo.toLowerCase()) != -1) return true
        return false
      })

  }, [itensContrato, itensAtuais, data.termo])

  const handleChange = (field, value) => {
    setData(data => ({ ...data, [field]: value }))
  }

  const handleChangeTermo = (value) => {
    setData(data => ({ ...data, termo: value, selecionado: null }))
  }

  const handleChangeQuantidade = (quantidade) => {
    setData(data => ({ ...data, quantidade }))
  }

  const handleAvancarSelecao = () => {
    handleChange('modo', MODO.COMPLETAR)
  }

  const handleSubmitConcluir = async (e) => {
    e.preventDefault()

    if (!justificativaValida) {
      toast('Informe a justificativa para continuar.')
      return
    }

    try {
      showLoading()
      const res = await ordemServicoService.addItem(config.idOrdemServico, data.selecionado.id, data.quantidade, data.justificativa)
      hideLoading()

      if (res.success) {
        toast('Registro salvo com sucesso!')
        onChange && onChange()
        onClosed && onClosed()
      } else {
        toast(res.message || 'Erro ao salvar o registro')
      }
    } catch (ex) {
      hideLoading()
      console.error(ex)
      erroInesperado()
    }
  }

  const handleCancelar = () => {
    onClosed && onClosed()
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        <h2>Adicionar item</h2>
        <hr />

        {data.modo == MODO.SELECAO_ITEM && (
          <div className="row">
            <h2 className="col-12 text-center">Passo 1 - Selecione o item a incluir</h2>
            <FormGroup className={`col-4`}>
              <label htmlFor="termo">Filtrar itens</label>
              <Input id="termo" type="text" value={data.termo || ''} onChange={e => handleChangeTermo(e.target.value)} />
            </FormGroup>
            <div className="col-12">
              <Table className="align-items-center table-flush">
                <thead>
                  <tr>
                    <th style={{ width: 40 }}></th>
                    <th>Item</th>
                    <th>Descrição</th>
                    <th>Unid</th>
                    <th className="text-right">Valor Unit.</th>
                  </tr>
                </thead>
                <tbody>
                  {itensFiltrados.map(el => (
                    <tr key={el.id}>
                      <td>
                        <input
                          type="radio"
                          name="selecionado"
                          value={el.id}
                          checked={data.selecionado?.id == el.id}
                          onChange={() => handleChange('selecionado', el)}
                        />
                      </td>
                      <td>{el.codigo}</td>
                      <td className="text-wrap">
                        {el.descricao}
                      </td>
                      <td>{el.unidade}</td>
                      <td className="text-right">R$ {el.precoUnitarioFmt}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="col-12 text-right">
              <Button color="primary" onClick={handleAvancarSelecao} disabled={!data.selecionado}>Avançar</Button>
              <Button color="primary" onClick={handleCancelar} outline>Cancelar</Button>
            </div>
          </div>
        )}

        {data.modo == MODO.COMPLETAR && (
          <form className="row" onSubmit={handleSubmitConcluir}>
            {config?.tipoContrato == TipoContratoEnum.SEMAFORICO ? (
              <h2 className="col-12 text-center">Passo 2 - Confirme a inclusão</h2>
            ) : (
              <h2 className="col-12 text-center">Passo 2 - Informe a quantidade</h2>
            )}
            <div className="col-12">
              <Table className="align-items-center table-flush">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Descrição</th>
                    <th>Unid</th>
                    <th className="text-right">Valor Unit.</th>
                    {config?.tipoContrato == TipoContratoEnum.NORMAL && (
                      <>
                        <th className="text-right">Quantidade</th>
                        <th className="text-right">Valor Total</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {[data.selecionado].map(el => (
                    <tr key={el.id}>
                      <td>{el.codigo}</td>
                      <td className="text-wrap">
                        {el.descricao}
                      </td>
                      <td>{el.unidade}</td>
                      <td className="text-right">R$ {formatNumber(el.precoUnitario)}</td>
                      {config?.tipoContrato == TipoContratoEnum.NORMAL && (
                        <>
                          <td>
                            <Input type="text" value={formatNumber(data.quantidade || 0)} onChange={e => handleChangeQuantidade(parseInt(onlyNumbers(e.target.value) || 0) / 100)} />
                          </td>
                          <td className="text-right">R$ {formatNumber(el.precoUnitario * (data.quantidade || 0))}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <FormGroup className="col-12">
              <label htmlFor="justificativa">
                Justificativa {justificativaObrigatoria ? '*' : '(opcional)'}
              </label>
              <Input
                id="justificativa"
                type="textarea"
                rows={4}
                value={data.justificativa || ''}
                onChange={e => handleChange('justificativa', e.target.value)}
                placeholder="Descreva o motivo da inclusão"
              />
              {justificativaObrigatoria && !justificativaValida && (
                <small className="text-danger">A justificativa é obrigatória para esta OS.</small>
              )}
            </FormGroup>
            <div className="col-12 text-right">
              <Button type="submit" color="primary" disabled={(data.quantidade || 0) <= 0 || !justificativaValida}>Concluir</Button>
              <Button color="primary" onClick={handleCancelar} outline>Cancelar</Button>
            </div>
          </form>
        )}
      </ModalBody>
    </Modal >
  )
}